import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"


const OPTIONS = [
    { label: 'Competition', value: 'competition' },
    { label: 'Parity', value: 'parity' },
]

export default function SelectSectionType({ ...props }) {

    const myProps = {
        options: OPTIONS,
        placeholder: 'All section types',
        isClearable: true, isMulti: true,
        icon: { icon: 'list' },
        ...props
    }

    return <SelectSeeker {...myProps} />
}